import React from 'react';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import CanPerform from 'components/CanPerform/CanPerform';
import Button from 'components/CustomButtons/Button';
import Add from '@material-ui/icons/Add';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/usersStyle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { BodyM, BodyMBold, HeadingSBold } from 'components/Typography/Typography';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IAddUserCardProps {
	title: string;
	icon: React.ReactElement;
	description: string;
	listTitle: string;
	listItems?: types.users.IListItem[];
	button?: types.users.IButton;
	className?: string;
}

const AddUserCard = ({ title, description, icon, listItems, listTitle, button, className }: IAddUserCardProps) => {
	const classes = useStyles();

	return (
		<GridItem xs={12} lg={4}>
			<Card
				className={classNames(classes.addUserCard, {
					[classes.addUserCardWithButton]: !!button,
					[className || '']: !!className,
				})}
			>
				<CardBody>
					<GridContainer justify="flex-start">
						<GridItem xs={12} className={classes.iconWrapper}>
							{icon}
						</GridItem>
						<GridItem xs={12} className={classes.infoWrapper}>
							<div>
								<HeadingSBold disableMargin>{title}</HeadingSBold>
							</div>
							<BodyM>{description}</BodyM>
						</GridItem>

						<GridItem xs={12} className={classes.divider} />
					</GridContainer>
					<BodyMBold>{listTitle}</BodyMBold>

					<div className={classes.listWrapper}>
						{listItems &&
							listItems.map((item, index) => (
								<div key={index}>
									{item.icon}
									<BodyM disableMargin>{item.text}</BodyM>
								</div>
							))}
					</div>
					<ConditionalRender
						show={!!button}
						onTrue={() => (
							<CanPerform
								action="users:add-user"
								yes={
									<div className={classes.addUserButtonWrapper}>
										<Button withIcon onClick={button!.onClick} color="primary-light">
											<>
												<Add />
												{button!.text}
											</>
										</Button>
									</div>
								}
							/>
						)}
					/>
				</CardBody>
			</Card>
		</GridItem>
	);
};

export default AddUserCard;
